// Styles for PointsCard

import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
export const StyledPointsCard = styled.div`
  .points-card-detail {
    .points {
      min-width: ${toRem(70)};
      display: inline-block;
      text-align: right;
    }

    &-description {
      ul {
        padding-left: ${toRem(24)};
      }

      div div p:last-child {
        margin-bottom: ${toRem(4)};
      }
    }
  }
`;
